import styled from 'styled-components';
import IdentityConfirmComponent from "modules/identity/components/IdentityConfirm";

export const IdentityConfirm = styled(IdentityConfirmComponent)`
  margin: 0 -6px;
`;